module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mrescirp8-b6a7f0a9ce128b035922d40bb6d1ea7e.jpg";